import React from 'react';
import MeetingLocalVideo from '../../MeetingLocalVideo';
import { FILL_STYLE } from '../meeting-tile-utils';

interface TileLocalFeedProps {
    isSecondary?: boolean;
}

/** The local sender's feed. */
const TileLocalFeed: React.FC<TileLocalFeedProps> = ({
    isSecondary = false,
}) => (
    <div style={FILL_STYLE}>
        <MeetingLocalVideo isSecondary={isSecondary} />
    </div>
);

// Memoized for the same resize reason as the sibling tiles: its only prop
// (isSecondary) is stable, so it shouldn't re-render as the grid re-lays out.
export default React.memo(TileLocalFeed);
